/* __next_internal_client_entry_do_not_use__ ImageUploaderStatus auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { formatBytes } from "@faire/web--source/common/formatBytes";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import * as React from "react";
import { Upload } from "../icons/foundation/Upload";
import { Spacer } from "../spacing";
export var ImageUploaderStatus = function(param) {
    var uploadCta = param.uploadCta, displayedFileTypes = param.displayedFileTypes, displayedMaxFileSize = param.displayedMaxFileSize, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, _param_error = param.error, error = _param_error === void 0 ? false : _param_error;
    var strictLocalize = useStrictLocalization().strictLocalize;
    if (isLoading) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(LoadingSpinner, {
                    color: Core.icon.default
                }),
                uploadCta ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "1x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            color: "inherit",
                            align: "center",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "rZ+nel",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Uploading..."
                                    }
                                ]
                            })
                        })
                    ]
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Upload, {
                color: "inherit",
                fontSize: "24px"
            }),
            uploadCta ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        color: error ? Core.text.critical : "inherit",
                        align: "center",
                        children: uploadCta
                    }),
                    displayedFileTypes || displayedMaxFileSize ? /*#__PURE__*/ _jsx(Spacer, {
                        size: "1x"
                    }) : null,
                    displayedFileTypes ? /*#__PURE__*/ _jsx(Typography, {
                        color: error ? Core.text.critical : "inherit",
                        align: "center",
                        variant: "labelSansRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "d4dQxN",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Accepts: "
                                },
                                {
                                    type: 1,
                                    value: "displayedFileTypesFullyTranslatedSentence"
                                }
                            ],
                            values: {
                                displayedFileTypesFullyTranslatedSentence: displayedFileTypes
                            }
                        })
                    }) : null,
                    displayedMaxFileSize ? /*#__PURE__*/ _jsx(Typography, {
                        color: error ? Core.text.critical : "inherit",
                        align: "center",
                        variant: "labelSansRegular",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "wAOWyq",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Maximum file size is "
                                },
                                {
                                    type: 1,
                                    value: "formatBytesNumberWithUnit"
                                }
                            ],
                            values: {
                                formatBytesNumberWithUnit: "".concat(formatBytes(displayedMaxFileSize, strictLocalize))
                            }
                        })
                    }) : null
                ]
            }) : null
        ]
    });
};
